export default __webpack_public_path__ + "static/media/mitsubishi.279b6118.svg";